/** Canonical route expense type catalog — SSOT for finance + completion UI. */

export const ROUTE_EXPENSE_TYPE_OPTIONS = [
  { value: 'STORAGE', label: 'Хранение' },
  { value: 'DOWNTIME', label: 'Простой' },
  { value: 'REPAIR', label: 'Ремонт' },
  { value: 'OVERLOAD', label: 'Перегруз' },
  { value: 'TOLL', label: 'Платные дороги' },
  { value: 'LOADERS', label: 'Грузчики' },
  { value: 'CRANE', label: 'Кран' },
  { value: 'COURIER', label: 'Курьер' },
  { value: 'PENALTY', label: 'Штраф' },
  { value: 'OTHER', label: 'Прочее' }
] as const;

export type RouteExpenseType = (typeof ROUTE_EXPENSE_TYPE_OPTIONS)[number]['value'];

const TYPE_LABEL_MAP: Record<string, string> = Object.fromEntries(
  ROUTE_EXPENSE_TYPE_OPTIONS.map((o) => [o.value, o.label])
);

export function routeExpenseTypeLabel(value: string | null | undefined): string {
  const k = String(value ?? '').trim().toUpperCase();
  if (!k) return '—';
  return TYPE_LABEL_MAP[k] ?? k;
}

export function normalizeRouteExpenseType(value: string | null | undefined): RouteExpenseType {
  const k = String(value ?? '').trim().toUpperCase();
  if (TYPE_LABEL_MAP[k]) return k as RouteExpenseType;
  return 'OTHER';
}
